import { Link } from 'react-router-dom';
import TopBar from '../components/TopBar';

// Rendered for /section/:period/:sectionKey when the section's phase hasn't released yet
// (diConfig sets section.phase.lockedForMe). Reached by a typed/bookmarked URL — Home shows
// the same message on the locked card instead of a link.
export default function PhaseLocked({ label, message }) {
  return (
    <>
      <TopBar />
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: 'calc(100vh - 52px)', gap: 12 }}>
        <i className="fas fa-lock" style={{ fontSize: '3rem', color: '#6b5a1e' }} />
        <h2 style={{ margin: 0, color: '#6b5a1e' }}>{label || 'This section'} isn’t open yet</h2>
        <p style={{ color: '#555', margin: 0 }}>{message}</p>
        <Link to="/" style={{ marginTop: 8 }}>Back to the dashboard</Link>
      </div>
    </>
  );
}
